export enum TemplatesWebPush {
  CREATE = '/templates/web-push/create',
  EDIT = '/templates/web-push/edit',
}
